const isOneDay = (_start, _end) => {
    let start = new Date(_start);
    if (!_end) return true;

    let end = new Date(_end);
    return (
        start.getDate() === end.getDate() &&
        start.getMonth() === end.getMonth() &&
        start.getFullYear() === end.getFullYear()
    );
};

const mapVFair = data => ({
    id: data.id,
    title: data.title,
    start: data.start_date,
    end: data.end_date,
    fee: data.fee,
    image: data.image,
    active: data.active,
    body: data.body,
    oneDayEvent: isOneDay(data.start_date, data.end_date),
    visibility: data.visibility,
    studentVisibility: data.studentVisibility,
    personalInvites: data.personalInvites,
    vFairType: data.vFairType,
    profileRequirementLevel: data.profileRequirementLevel,
});

export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    authorize: true,
    template: ['VFAIRS_TEMPLATE', mapVFair],
    GET: {},
    '/:id': {
        template: ['VFAIR_TEMPLATE', mapVFair],
        GET: {},
        '/organizations': {
            authorize: true,
            template: [
                'VFAIRORGANIZATIONS_TEMPLATE',
                data => ({
                    vfairId: data.vfairId,
                    id: data.vfairId + '_' + data.organizationId,
                    organizationId: data.organizationId,
                    backgroundImage: data.backgroundImage,
                    email: data.email,
                    facebook: data.facebook,
                    instagram: data.instagram,
                    linkedIn: data.linkedIn,
                    logo: data.logo,
                    phone: data.phone,
                    presentation: data.presentation,
                    status: data.status,
                    tagline: data.tagline,
                    title: data.title,
                    twitter: data.twitter,
                    url: data.url,
                    vimeo: data.vimeo,
                    weChat: data.weChat,
                    youTube: data.youTube,
                }),
            ],
            GET: {},
            '/:organizationId': {
                authorize: true,
                template: [
                    'VFAIRORGANIZATIONS_TEMPLATE',
                    data => ({
                        vfairId: data.vfairId,
                        id: data.vfairId + '_' + data.organizationId,
                        organizationId: data.organizationId,
                        backgroundImage: data.backgroundImage,
                        email: data.email,
                        facebook: data.facebook,
                        instagram: data.instagram,
                        linkedIn: data.linkedIn,
                        logo: data.logo,
                        phone: data.phone,
                        presentation: data.presentation,
                        status: data.status,
                        tagline: data.tagline,
                        title: data.title,
                        twitter: data.twitter,
                        url: data.url,
                        vimeo: data.vimeo,
                        weChat: data.weChat,
                        youTube: data.youTube,
                    }),
                ],
                GET: {},
            },
        },
        '/events': {
            authorize: true,
            template: ['VFAIREVENTS_TEMPLATE', data => data],
            GET: {},
            '/:id': {
                authorize: true,
                template: ['VFAIREVENTS_TEMPLATE', data => data],
                GET: {},
            },
        },
    },
};
